<nz-drawer
  nzPlacement="right"
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzClosable]="true"
  [nzExtra]="showButtons ? buttons : undefined"
  [nzMaskClosable]="false"
  [nzTitle]="title"
  [nzVisible]="visible"
  [nzWidth]="drawerWidth"
  (nzOnClose)="onCloseButtonClick()">
  <ng-container *nzDrawerContent>
    <ng-content></ng-content>
  </ng-container>
</nz-drawer>
<ng-template #buttons>
  <div class="d-flex buttons-container">
    @if (currentStatus) {
      <ui-platform-status-marker
        [menuItems]="statusItems"
        [status]="currentStatus">
      </ui-platform-status-marker>
    }
    <ui-platform-button
      class="cancel-button"
      type="secondary"
      [label]="cancelLabel | transloco"
      (click)="onCloseButtonClick()">
    </ui-platform-button>
    <ui-platform-button
      type="primary"
      *ngIf="isConfirmButtonVisible"
      [inProgress]="inProgress"
      [label]="confirmLabel | transloco"
      (click)="onConfirmButtonClick()">
    </ui-platform-button>
    <ui-platform-menu
      type="text"
      icon="dots"
      triggerMode="click"
      *ngIf="menuItems.length"
      [lighterIcon]="true"
      [menuItems]="menuItems">
    </ui-platform-menu>
  </div>
</ng-template>
